import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { Button, Grid } from "@mui/material";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { IFormValues } from "../types";
import { AncillarySubtype } from "../../../api/services";
import { RentalType } from "../../../types";
import BasicDetails from "./sections/basic-details/BasicDetails";
import ExtraServices from "./sections/extra-services/ExtraServices";
import TotalToBePaid from "./sections/total-to-be-paid/TotalToBePaid";
import FirstDriverDetails from "./sections/first-driver/FirstDriverDetails";
import InvoiceDetails from "./sections/invoice/InvoiceDetails";
import BookingOwnerDetails from "./sections/booking-owner/BookingOwnerDetails";
import AdditionalDriversDetails from "./sections/additional-drivers/AdditionalDriversDetails";
import ButtonBookFullEdit from "./buttons/ButtonBookFullEdit";

const EditSections = (props: {bookingId: string | undefined}) => {

    const { t } = useTranslation('booking');

    const navigate = useNavigate();

    const additionalDriversAncillary = useWatch<IFormValues>({
        name: `extraServices.ancillary.${AncillarySubtype.AdditionalDrivers}`
    });

    const rentalType = useWatch<IFormValues, 'basicDetails.rentalType'>({
        name: 'basicDetails.rentalType'
    });

    const handleReset = useCallback(() => {
        window.history.replaceState({}, document.title);
        navigate(0);
    }, []);

    return (
        <Grid container spacing={2} alignItems="start">
            <Grid container item xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <BasicDetails />
                </Grid>
                <Grid item xs={12}>
                    <ExtraServices />
                </Grid>
                <Grid item xs={12}>
                    <TotalToBePaid />
                </Grid>
            </Grid>
            <Grid container item xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <FirstDriverDetails />
                </Grid>
                {rentalType === RentalType.CORPORATE &&
                    <Grid item xs={12}>
                        <InvoiceDetails/>
                    </Grid>
                }
                <Grid item xs={12}>
                    <BookingOwnerDetails />
                </Grid>
                {additionalDriversAncillary ?
                    <Grid item xs={12}>
                        <AdditionalDriversDetails />
                    </Grid>
                    : undefined
                }
                <Grid container item mt={1} justifyContent="end" columnGap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleReset}
                    >
                        {t('label.reset')}
                    </Button>
                    <ButtonBookFullEdit bookingId={props.bookingId}/>
                </Grid>
            </Grid>
        </Grid>
    );

}

export default EditSections;
